import { memo } from "react"

import styled, { css } from "styled-components"

import { colors, spacing } from "@izettle/otto"

import { SemanticState } from "../../enumerations"
import { Icon } from "../icon"

import { InputIconProps } from "./types"

const mixinInputControlLeftPalette = css<InputIconProps>`
  color: ${({ isDisabled }) => {
    if (isDisabled) {
      return colors.icon.disabled
    }
  }};
`

const mixinInputControlRightPalette = css<InputIconProps>`
  color: ${({ semanticState, isFocused, isDisabled }) => {
    if (isDisabled) {
      return colors.icon.disabled
    }
    if (isFocused) {
      return colors.icon.action
    }
    return {
      [SemanticState.Warning]: colors.icon.warning.small,
      [SemanticState.Error]: colors.icon.error.small,
      [SemanticState.Success]: colors.icon.success.small,
      [SemanticState.Default]: colors.icon.default,
    }[semanticState ?? SemanticState.Default]
  }};
`

const InputIconGeneric = styled(Icon)<InputIconProps>`
  font-size: 24px;
  min-height: 100%;
  display: flex;
  align-items: center;
  transition: color 0.1s cubic-bezier(0.25, 0.1, 0.25, 1);
  outline: none;
`

export const InputIconLeftMemoized = memo(styled(InputIconGeneric)<InputIconProps>`
  color: ${colors.icon.default};
  padding-left: ${spacing.small};
  ${mixinInputControlLeftPalette}
`)

export const InputIconMemoized = memo(styled(InputIconGeneric)<InputIconProps>`
  padding-right: ${spacing.small};
  ${mixinInputControlRightPalette}
`)
